module.exports = __webpack_public_path__ + "static/img/cargo-content-2.50dc7aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cargo-content-2.png
// module id = fvij
// module chunks = 0